import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthStoreService } from '@app/core/services/auth-store.service';
import { StorageService } from '@app/core/services/storage.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authStore = inject(AuthStoreService);
  const storage = inject(StorageService);
  const token = authStore.token();

  if (!token || !request.url.includes('/api/')) {
    return next(request);
  }

  const selectedClientAccountId = storage.getSelectedClientAccountId();
  return next(request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      ...(selectedClientAccountId ? { 'X-Client-Account-Id': selectedClientAccountId } : {})
    }
  }));
};
